import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { LeadCloudFileType } from '@econtractor/types';
import type { CloudUploadScope } from 'api/apiCloudflare';
import { FilesContainer } from 'modules/files';
import SolarIcon from 'components/icons/SolarIcon';

export interface CustomerFormFilesProps {
    files: LeadCloudFileType[];
    clientCustomerId?: number;
    vendorCustomerId?: number;
    canEdit?: boolean;
    saveFirstMessage: string;
    onFilesChange: (nextFiles: LeadCloudFileType[]) => Promise<boolean>;
    onEnsureEntity?: () => Promise<CloudUploadScope | false>;
}

const CustomerFormFiles = ({
    files,
    clientCustomerId = 0,
    vendorCustomerId = 0,
    canEdit = false,
    saveFirstMessage,
    onFilesChange,
    onEnsureEntity,
}: CustomerFormFilesProps) => {
    const { t } = useTranslation(['Objects', 'FileNavigator', 'common']);

    return (
        <Accordion className="mb-3">
            <Accordion.Item eventKey="customer-files">
                <Accordion.Header>
                    <span className="text-muted fw-medium">
                        <SolarIcon name="paperclip" className="me-1 fs-14" />
                        {t('customer.filesTitle')}
                        {files.length ? ` (${files.length})` : ''}
                    </span>
                </Accordion.Header>
                <Accordion.Body>
                    <FilesContainer 
                        files={files}
                        scope={{
                            clientCustomerId: Number(clientCustomerId || 0),
                            vendorCustomerId: Number(vendorCustomerId || 0),
                        }}
                        imageColProps={{ xs: 6, md: 4, lg: 3 }}
                        noShowPreviewImages
                        canEdit={canEdit}
                        addButtonLabel={t('btnAddFiles')}
                        uploadingLabel={t('common:buttons.uploading')}
                        saveFirstMessage={saveFirstMessage}
                        errorMessage={t('common:messError')}
                        uploadSuccessMessage={t('FileNavigator:messDownloadSuccess')}
                        onFilesChange={onFilesChange}
                        onEnsureEntity={onEnsureEntity}
                    />
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default CustomerFormFiles;
